import React from "react"
import { Box, Flex, Button, Text, Image } from "rebass"
import Flickity from "flickity"
import { motion } from "framer-motion"

import LeftArrowIcon from "../images/left-arrow.svg"
import RightArrowIcon from "../images/right-arrow.svg"
import HoverCursor from "../images/cursor-hover.png"
import FloatingBox from "./floating-box"
import Cloud from "./cloud"

const BlueCloud = () => (
  <Box
    css={{ position: "absolute", zIndex: 10 }}
    sx={{ bottom: [0, 0], right: 0 }}
  >
    <motion.div
      animate={{ x: "-100vw" }}
      transition={{ duration: 200, yoyo: Infinity }}
    >
      <Cloud color="#007CFF" />
    </motion.div>
  </Box>
)

const LeftArrowButton = props => (
  <Button
    {...props}
    css={{ cursor: `url(${HoverCursor}), auto` }}
    variant="transparent"
  >
    <Image width={2 / 3} src={LeftArrowIcon} />
  </Button>
)

const RightArrowButton = props => (
  <Button
    {...props}
    css={{ cursor: `url(${HoverCursor}), auto` }}
    variant="transparent"
  >
    <Image width={2 / 3} src={RightArrowIcon} />
  </Button>
)

const Slide = ({ children }) => (
  <Box css={{ height: "100%" }} width={1}>
    <Flex
      alignItems="center"
      justifyContent="center"
      css={{ height: "100%" }}
      flexDirection="column"
      flex={1}
    >
      <Box
        px={[4, 0]}
        css={{ textAlign: "center" }}
        width={[1, 2 / 3]}
        mx="auto"
      >
        {children}
      </Box>
    </Flex>
  </Box>
)

const Carousel = ({ quotes, size }) => {
  const [currentIndex, setCurrentIndex] = React.useState(0)
  let flktyRef = React.useRef()
  let fltkyContainer = React.useRef()

  React.useEffect(() => {
    flktyRef = new Flickity(fltkyContainer.current, {
      cellAlign: "left",
      prevNextButtons: false,
      pageDots: false,
      contain: true,
      setGallerySize: false,
      // adaptiveHeight: false,
      // autoPlay: 5000,
    })
    flktyRef.resize()

    flktyRef.on("change", index => {
      setCurrentIndex(index)
    })
  }, [flktyRef])

  const handlePrevious = React.useCallback(() => {
    flktyRef.previous()
  }, [flktyRef])

  const handleNext = React.useCallback(() => {
    flktyRef.next()
  }, [flktyRef])

  return (
    <Box
      sx={{ borderColor: "text", position: "relative" }}
      css={{ borderTop: "2px solid" }}
    >
      <FloatingBox
        initialPos={{ x: 0, y: 0 }}
        width={size.size.width}
        height={size.size.height}
      />

      <BlueCloud />

      <Flex>
        <Flex
          width={[48, 60]}
          alignItems="center"
          justifyContent="center"
          sx={{ borderColor: "text" }}
          css={{ borderRight: "2px solid" }}
        >
          <LeftArrowButton
            disabled={currentIndex === 0}
            onClick={handlePrevious}
          >
            Back
          </LeftArrowButton>
        </Flex>
        <Box flex={1}>
          <Box css={{ height: 450 }} flex={1} width={1} ref={fltkyContainer}>
            {quotes.map((q, i) => (
              <Slide key={i}>
                <Text variant="quote">
                  &ldquo;
                  <span dangerouslySetInnerHTML={{ __html: q.body }} />
                  &rdquo;
                </Text>
                <Text fontFamily="body" mt={4}>
                  —
                  <span dangerouslySetInnerHTML={{ __html: q.citation }} />
                </Text>
              </Slide>
            ))}
          </Box>
        </Box>
        <Flex
          width={[48, 60]}
          alignItems="center"
          justifyContent="center"
          sx={{ borderColor: "text" }}
          css={{ borderLeft: "2px solid" }}
        >
          <RightArrowButton
            disabled={currentIndex === quotes.length - 1}
            onClick={handleNext}
          >
            Next
          </RightArrowButton>
        </Flex>
      </Flex>
    </Box>
  )
}

export default Carousel
